export enum EWaitListsStatus {
  WAITING = 'WAITING',
  CANCELED = 'CANCELED',
  USER_CANCELED = 'USER_CANCELED',
  FINISHED = 'FINISHED',
}


export default EWaitListsStatus;
